import { LuIcon } from "@overmap-ai/blocks"
import type { FormSubmission, Stored } from "@overmap-ai/common"
import { forwardRef, memo } from "react"

import { FormSubmissionIndexLabel } from "../../../components/IndexLabels/FormSubmissionIndexLabel"
import { modelIconMapping } from "../../../mappings/icons"
import {
	MentionListEmpty,
	MentionListItem,
	type MentionListRef,
	MentionListRoot,
	type MentionListRootProps,
} from "../../blocks"

type FormSubmissionMentionListProps = MentionListRootProps<Stored<FormSubmission>>

export const FormSubmissionMentionList = memo(
	forwardRef<MentionListRef<Stored<FormSubmission>>, FormSubmissionMentionListProps>((props, ref) => {
		const { items } = props

		return (
			<MentionListRoot<Stored<FormSubmission>> ref={ref} {...props}>
				{items.map((submission) => (
					<MentionListItem<Stored<FormSubmission>> item={submission} key={submission.uuid}>
						<LuIcon icon={modelIconMapping.form} />
						<FormSubmissionIndexLabel formSubmissionId={submission.uuid} />
					</MentionListItem>
				))}
				<MentionListEmpty>No results</MentionListEmpty>
			</MentionListRoot>
		)
	}),
)
FormSubmissionMentionList.displayName = "FormSubmissionMentionList"
